import Entity from './entity';
export default class PassengerType extends Entity<number> {
  name: string;
  creationTime: string;
  creatorUserId: any;
}
